import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    FlowOfFunds,
    SaveConsiderationRowRequest,
    ConsiderationFieldValue,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

const ConflictStatusCode = 409;

export interface SaveConsiderationRowParams extends SaveConsiderationRowRequest {
    engagementId: number;
    section: number;
    rowKey: number;
}

export interface SaveConsiderationRowRejection {
    isConflict: boolean;
}

export const SaveConsiderationRow = createAsyncThunk(
    'flowOfFunds/saveConsiderationRow',
    async (params: SaveConsiderationRowParams, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/PurchasePriceConsideration/${params.engagementId}/Rows/${params.section}/${params.rowKey}`,
                {
                    version: params.version,
                    values: params.values,
                }
            );

            if (response.status === ConflictStatusCode) {
                return dispatch.rejectWithValue({
                    isConflict: true,
                } as SaveConsiderationRowRejection);
            }

            if (response.status !== 200) {
                throw new Error('Failed to save the row');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification('Could not save the row changes.', 'error');
            return dispatch.rejectWithValue({
                isConflict: false,
            } as SaveConsiderationRowRejection);
        }
    }
);
